<script>
import selectApprovers from "../form/selectApprovers.vue";

export default {
  name: "modalEditGroup",
  components: {
    selectApprovers,
  },
  data: function () {
    return {
      instanceId: this.$A.GetUUID(),
      visible: false,
      saving: false,
      nameError: false,
      group: {
        id: 0,
        name: "",
        approverIds: [],
      },
    };
  },
  computed: {
    selectedMembers() {
      return this.group.approverIds.map((id) => ({ id }));
    },
  },
  methods: {
    open: function (group) {
      this.group = group
        ? {
            id: group.id,
            name: group.name,
            approverIds: (group.approverIds || []).slice(),
          }
        : { id: 0, name: "", approverIds: [] };
      this.nameError = false;
      this.visible = true;
      this.$bvModal.show(this.instanceId);
    },
    close: function () {
      this.$bvModal.hide(this.instanceId);
    },
    save: async function () {
      if (this.saving) return;
      if (!this.group.name || this.group.name.trim().length === 0) {
        this.nameError = true;
        this.$A.AlertUser("Please Name Your Group Before Saving");
        return;
      }

      const memberSelect = this.$refs.groupMemberSelect;
      const approverIds = memberSelect
        ? memberSelect.getSelectedApprovers().map((a) => a.id)
        : this.group.approverIds;

      this.saving = true;
      try {
        const saved = await this.$A.ApproverGroupService.Save({
          id: this.group.id,
          name: this.group.name.trim(),
          approverIds: approverIds,
        });
        if (saved) {
          this.$emit("groupSaved", saved);
          this.close();
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<template>
  <!-- Create / Edit Approval Group Modal -->
  <b-modal :id="instanceId" size="lg" @hidden="visible = false">
    <template v-slot:modal-header>
      <alertHeader />
      <div class="w-100 px-4 pt-4" style="margin-bottom: 20px">
        <div class="header-text">
          {{ group.id > 0 ? "Edit Approval Group" : "Create Approval Group" }}
        </div>
        <span class="sub-text"
          >Group contacts together so you can add them to a workflow all at
          once.</span
        >
      </div>
    </template>

    <div v-if="visible">
      <div class="form-group">
        <label class="field-label">Group Name</label>
        <b-form-input
          v-model="group.name"
          :class="{ 'is-invalid': nameError }"
          placeholder="Ex: Marketing Team"
          maxlength="400"
          data-cy="group-name-input"
          @input="nameError = false"
        />
        <div v-if="nameError" class="invalid-feedback d-block">
          Group name is required.
        </div>
      </div>
      <div class="form-group mb-0">
        <label class="field-label">Contacts</label>
        <selectApprovers
          ref="groupMemberSelect"
          :key="instanceId + group.id"
          :SelectedApprovers="selectedMembers"
          :isUpdateProofOptionsModal="true"
          placeholder="Search contacts..."
          testingId="group-member-select"
        />
      </div>
    </div>

    <template v-slot:modal-footer>
      <div class="w-100 d-flex justify-content-end align-items-center">
        <b-button class="gray-btn" @click="close()">Cancel</b-button>
        <b-button class="green-btn" @click="save()" data-cy="save-group-btn"
          >Save</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<style scoped>
.field-label {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #252526;
}

.gray-btn {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #444444;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 38px;
  filter: drop-shadow(0px 1px 2px rgba(8, 11, 13, 0.05));
  border-radius: 6px;
  padding: 10px !important;
}

.green-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 38px;
  background: #019256;
  box-shadow: 0px 1px 2px rgb(8 11 13 / 5%);
  border-radius: 6px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-left: 20px;
  padding: 9px 17px !important;
}

.gray-btn:hover {
  background-color: lightgray;
  border: lightgray solid 1px;
}

.header-text {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #252526;
  margin-bottom: 20px;
}

.sub-text {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #575759;
}

::v-deep .modal-header {
  padding: 0px !important;
}

::v-deep .modal-body {
  padding: 24px !important;
  min-height: 260px;
}
</style>
